import { GridRowId } from "@mui/x-data-grid-pro";
import React from "react";

export const DataGridValidationContext = React.createContext<DataGridValidationContextValue | undefined>(undefined);

export interface DataGridValidationContextValue {
	setError(rowId: GridRowId, fieldName: string, error: string | undefined): void;
}
